<template>
  <q-card square >
    <div v-for="(step, index) in steps" class="step" :key="index">
        <span>
          <strong>{{step.name}}</strong>
        </span>
      <span style="margin-left:5px">
          <strong>{{step.subTitle}}</strong>
        </span>
      <div>{{step.description}}</div>
      <div
          v-for="(subStep, index) in step.subDescription"
          class="inner-step"
          :key="index"
          :style="index === 0 ? 'margin-top:10px' : ''"
      >
          <span>
            <strong>{{subStep.val}}</strong>
            -
            {{subStep.description}}
          </span>
      </div>
    </div>
  </q-card>
</template>

<script>
export default {
name: "DimishedValueDescription",
  data() {
    return {
      steps: [
        {
          name: "Step One:",
          subTitle: "Check your car’s Market value",
        },
        {
          name: "Step Two:",
          subTitle: "Calculate the base loss of value.",
          description:
              "Insurance companies commonly apply a 10% cap, also known as the base loss of value. This simply means that the maximum amount for diminished value claims are 10% of the appraisal.",
        },
        {
          name: "Step Three:",
          subTitle: "Apply a damage multiplier.",
          description:
              "Insurance companies use a damage multiplier to adjust the base loss of value from step two. In other words, the cap established above is multiplied by a number ranging from 0.00 to 1.00 to arrive at an adjusted figure for diminished value based on the insurer’s determination of damage. The figure that the base loss of value is multiplied by begins at 0.00 for cars with no structural damage or replaced panels, and can go as high as 1.00 for cars with severe structural damage.",
          subDescription: [
            {
              val: "1.00",
              description: "Severe structural damage",
            },
            {
              val: "0.75",
              description: "Major damage to structure and panels",
            },
            {
              val: "0.50",
              description: "Moderate damage to structure and panels",
            },
            {
              val: "0.25",
              description: "Minor damage to structure and panels",
            },
            {
              val: "0.00",
              description: "No structural damage or replaced panels",
            },
          ],
        },
        {
          name: "Step Four:",
          subTitle: "Apply a mileage multiplier.",
          description:
              "The mileage multiplier functions the same way as the damage multiplier. The mileage multiplier reduces the—now adjusted—base loss of value depending on how many miles the vehicle has on its odometer. This means that an older car’s value will generally be lower than a newer car. The adjusted base loss of value from step three is multiplied by the appropriate mileage multiplier to arrive at the diminished value.",
          subDescription: [
            {
              val: "1.00",
              description: "0-19,999 miles",
            },
            {
              val: "0.80",
              description: "20,000-39,999 miles",
            },
            {
              val: "0.60",
              description: "40,000-59,999 miles",
            },
            {
              val: "0.40",
              description: "60,000-79,999 miles",
            },
            {
              val: "0.20",
              description: "80,000-99,999 miles",
            },
            {
              val: "0.00",
              description: "100,000 miles or more",
            },
          ],
          endDescription:
              "Every state has its own laws regarding diminished value and you can contact your state’s department of insurance to inquire about laws in your state. ",
        },
      ],
    };
  },
}
</script>